import React from 'react';
import { Instagram, Youtube, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-black border-t border-white/10 pb-20 lg:pb-0">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          <div>
            <h3 className="font-serif text-2xl text-white mb-4">Wedding Video Essex</h3>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Award-winning wedding videography and photography. Capturing your love story since 2015.
            </p>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/weddingvideoessex/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-gold hover:text-black text-white/60 flex items-center justify-center transition-all">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://www.youtube.com/@weddingvideoessex" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-gold hover:text-black text-white/60 flex items-center justify-center transition-all">
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Get in touch</h4>
            <div className="space-y-3">
              <a href="tel:01277280512" className="flex items-center gap-3 text-white/50 hover:text-gold text-sm transition-colors">
                <Phone className="w-4 h-4" /> 01277 280512
              </a>
              <a href="mailto:hello@weddingvideo.co.uk" className="flex items-center gap-3 text-white/50 hover:text-gold text-sm transition-colors">
                <Mail className="w-4 h-4" /> hello@weddingvideo.co.uk
              </a>
                <div className="flex items-start gap-3 text-white/50 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Unit 6 Hodgson Court, Hodgson Way,<br />Wickford, Essex, SS11 8XR</span>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col items-center gap-2">
          <p className="text-white/30 text-xs text-center">
            &copy;2026 - <a href="https://weddingvideo.co.uk" target="_blank" rel="noopener noreferrer" className="hover:text-white/60 transition-colors underline">Wedding Video Essex</a> LTD. Part of <a href="https://wvegroup.co.uk" target="_blank" rel="noopener noreferrer" className="hover:text-white/60 transition-colors underline">The WVE Group</a>.
          </p>
          <p className="text-white/30 text-xs text-center">
            Company Number 14540833. VAT Number - GB512923606.
          </p>
          <div className="flex gap-6 mt-2">
            <a href="/terms" className="text-white/30 hover:text-white/60 text-xs transition-colors">Terms</a>
            <a href="/privacy" className="text-white/30 hover:text-white/60 text-xs transition-colors">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
